import { render } from "./ShimmerPersonalizedOffer.vue?vue&type=template&id=4e23df08"
import script from "./ShimmerPersonalizedOffer.vue?vue&type=script&lang=js"
export * from "./ShimmerPersonalizedOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__